<script lang="ts">
    let {
        clickRight,
        clickLeft,
        type = "bright",
    }: {
        clickRight: () => void
        clickLeft: () => void
        type: "bright" | "dark"
    } = $props()
</script>

<nav class="controls {type}">
    <button onclick={clickLeft} aria-label="Slide left">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20" fill="none">
            <path d="M10.5 1L1.5 10L10.5 19" stroke={type == "bright" ? "#FFF" : "#242220"}></path>
        </svg>
    </button>
    <button onclick={clickRight} aria-label="Slide right">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20" fill="none">
            <path d="M0.5 1L9.5 10L0.5 19" stroke={type == "bright" ? "#FFF" : "#242220"}></path>
        </svg>
    </button>
</nav>

<style lang="less">
    nav {
        display: flex;
        gap: 1.2rem;
        z-index: 100;
        button {
            width: 2.4rem;
            height: 2.4rem;
            padding: 0.5rem;
            border-radius: 100px;
            border: 1px solid var(--dark-100);
            &:first-child {
                svg {
                    transform: translateX(-25%);
                }
            }
            &:last-child {
                svg {
                    transform: translateX(25%);
                }
            }
        }
        &.bright {
            button {
                border-color: var(--bright-100);
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>
